/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportState } from './reportState';
import { AddressView } from './addressView';
import { RdSAPAssessmentReportEnergyData } from './rdSAPAssessmentReportEnergyData';
import { RdSAPAssessmentReportDates } from './rdSAPAssessmentReportDates';


/**
 * Data needed to identify the Report. 
 */
export interface RdSAPAssessmentReportSummary { 
    reportState?: ReportState;
    /**
     * `RdSAP Assessment Report` Number.  The Unique Id & primary index for storage.  This value is globally unique.    Also known as the “Scheme reference”.    This is generated from the `inspection date` and the `address reference`.    Note: `Assessment date` and `inspection date` are used interchangeably. 
     */
    reportReferenceNumber: string;
    energyData?: RdSAPAssessmentReportEnergyData;
    reportDates?: RdSAPAssessmentReportDates;
    /**
     * The assessors QUID id
     */
    assessorQuid: string;
    address: AddressView;
    /**
     * Numerical representation of the transaction type of the report
     */
    transactionType: number;
}

